export const SEND_KAOMOJI = 'Send Kaomoji'; // kaomoji, source, category
export const ADD_KAOMOJI = 'Save Kaomoji'; // kaomoji, count
export const REMOVE_KAOMOJI = 'Delete Kaomoji'; // kaomoji, count
